
export const loadGoogleMaps = (callback) => {
    // 1) La API YA está cargada en memoria: usarla directo, NO re-inyectar el script.
    //    (Aunque removeGoogleMaps haya quitado el <script>, window.google sigue vivo;
    //    re-inyectar es lo que dispara "included multiple times".)
    if (window.google && window.google.maps) {
        if (callback) callback();
        return;
    }

    // 2) El script ya está en el DOM pero todavía cargando: engancharse a su load.
    const existingScript = document.getElementById('googleMaps');
    if (existingScript) {
        if (callback) existingScript.addEventListener('load', callback, { once: true });
        return;
    }

    // 3) Primera carga: inyectar una sola vez.
    const script = document.createElement('script');
    script.src = 'https://maps.google.com/maps/api/js?key=AIzaSyAZNnAAUdLjXR2GGOkyBABC1ch4_o38i2U&callback=Function.prototype';
    script.id = 'googleMaps';
    script.async = true;
    script.defer = true;
    if (callback) script.addEventListener('load', callback, { once: true });
    document.body.appendChild(script);
};



export const removeGoogleMaps = () => {
    // No-op intencional. Antes borraba el <script> de Google Maps al desmontar el
    // componente, pero la API JS ya quedó ejecutada en window.google y NO se
    // descarga al quitar el tag: el resultado era re-inyectar el script en el
    // próximo montaje -> el warning "included the Google Maps JavaScript API
    // multiple times" (+ error 'ZL' no fatal). La API se carga UNA vez y se
    // reutiliza durante toda la sesión (ver loadGoogleMaps, que es idempotente).
};
                